import { createFileRoute } from '@tanstack/react-router';

import { useIDNGet } from '~/api/query/idnGet';
import { IDNProfileModal } from '~/components/modals/IDNProfileModal';
import { USER_ROLES } from '~/features/auth/roles';
import { protectedRoute } from '~/utils/routesAuthorization';

const TEST_ID = 'idn-details';

export const Route = createFileRoute('/customer-admin/idns/$IDNId')({
  component: IDNProfileRoute,
  params: {
    parse: (params) => ({ IDNId: params.IDNId }),
  },
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.AdminAbbott, USER_ROLES.AbbottUser],
    });
  },
});

function IDNProfileRoute() {
  const { IDNId } = Route.useParams();
  const { data, isLoading, error } = useIDNGet(IDNId);

  return (
    <IDNProfileModal
      testID={TEST_ID}
      isLoading={isLoading}
      idn={data}
      error={error}
      onCloseRedirectPath={Route.fullPath}
    />
  );
}
